import React, { Component } from 'react';


import './available-rates.scss';

import { StringWms } from '../../../../assets/ts/StringWms.ts';
// Component
import WmsModel from '../../components/WmsModel/WmsModel.jsx';
import WmsButton from '../../components/WmsButton/WmsButton.jsx';
import WmsFormGrid from '../../components/WmsFormGrid/WmsFormGrid.jsx';
import * as GlobalService from '../../global_services';
import * as smallParcelService from '../smallParcel.service.jsx';
import ViewRateShoppingWarnings from "./view-rate-shopping-warnings.component";
import ViewRateShoppingDetails from "./view-rate-shopping-details.component";

export class AvailableRates extends Component {

    constructor(props) {
        super(props);


        this.$rootScope = window;
        this.translate = window.translate;
        let gridHeaders = StringWms.convertSringToOption(this.translate('AvailableRates_GridHeaders'));
        this._isMounted = false;
        this.warningsLinkElement = null;
        let tmpGridColumns = [
            {
                field: "Carrier",
                title: gridHeaders[0].description,
                width: 120
            }, {
                field: "Service",
                title: gridHeaders[1].description,
                width: 240
            }, {
                field: "DeliveryDate",
                title: gridHeaders[2].description,
                width: 180,
                template: "#= DeliveryDate != null && DeliveryDate != '0001-01-01T00:00:00' ? kendo.toString(kendo.parseDate(DeliveryDate), 'MM/dd/yyyy by hh:mm tt') : '-' #"
            }, {
                field: "Rate",
                title: gridHeaders[3].description,
                width: 180,
                sortable: {
                    compare: function (a, b, descending) {
                        if (descending) {
                            return a.Rate === b.Rate ? 0 : (a.Rate > b.Rate) ? 1 : -1;
                        } else {
                            return a.Rate === b.Rate ? 0 : (a.Rate < b.Rate) ? -1 : 1;
                        }
                    }
                },
                template: function (dataItem) {
                    if (dataItem.RateDetails) {
                        return `<div class="rate-details">${parseFloat(dataItem.Rate.total).toFixed(2)}</a>`;
                    } else {
                        return parseFloat(dataItem.Rate.total).toFixed(2)
                    }
                }

            }, {
                field: "CarrierAccount",
                title: gridHeaders[4].description,
                width: 120
            }, {
                field: "Nickname",
                title: gridHeaders[5].description,
                width: 120
            }
        ]
        if (props.orderInfoResponse.smallParcelRateBeforeAndAfterMarkup) {
            tmpGridColumns.splice(4, 0,  {
                field: "MarkupRate",
                title: gridHeaders[6].description,
                width: 180,
                sortable: {
                    compare: function (a, b, descending) {
                        // calculate mark up for first row
                        let aRate = 0
                        let aPercentage  = 0
                        let aFlatRate  = 0
                        if (a.FlatRateMarkup && a.PercentMarkup) {
                            aPercentage = ((a.Rate.total * a.PercentMarkup) / 100);
                            aFlatRate = a.FlatRateMarkup;
                        } else if (a.FlatRateMarkup && !a.PercentMarkup) {
                            aFlatRate = a.FlatRateMarkup;
                        } else if (!a.FlatRateMarkup && a.PercentMarkup) {
                            aPercentage = ((a.Rate.total * a.PercentMarkup) / 100);
                        }
                        aRate = a.Rate.total + aPercentage + aFlatRate

                        // calculate mark up for second row
                        let bRate = 0
                        let bPercentage  = 0
                        let bFlatRate = 0
                        if (b.FlatRateMarkup && b.PercentMarkup) {
                            bPercentage = ((b.Rate.total * b.PercentMarkup) / 100);
                            bFlatRate = b.FlatRateMarkup;
                        } else if (b.FlatRateMarkup && !b.PercentMarkup) {
                            bFlatRate = b.FlatRateMarkup;
                        } else if (!b.FlatRateMarkup && b.PercentMarkup) {
                            bPercentage = ((b.Rate.total * b.PercentMarkup) / 100);
                        }
                        bRate = b.Rate.total + bPercentage + bFlatRate

                        if (descending) {
                            return aRate === bRate ? 0 : (aRate > bRate) ? 1 : -1;
                        } else {
                            return aRate === bRate ? 0 : (aRate < bRate) ? -1 : 1;
                        }
                    }
                },
                template: function (dataItem) {
                    if (props.orderInfoResponse.smallParcelRateBeforeAndAfterMarkup) {
                        let markupText = `(no markup)`
                        let rate = 0
                        let percentage  = 0
                        let flatRate  = 0
                        if (dataItem.FlatRateMarkup && dataItem.PercentMarkup) {
                            percentage = ((dataItem.Rate.total * dataItem.PercentMarkup) / 100);
                            flatRate = dataItem.FlatRateMarkup;
                            markupText = `(+ ${dataItem.PercentMarkup}%, + $${dataItem.FlatRateMarkup})`
                        } else if (dataItem.FlatRateMarkup && !dataItem.PercentMarkup) {
                            flatRate = dataItem.FlatRateMarkup;
                            markupText = `(+ $${dataItem.FlatRateMarkup})`
                        } else if (!dataItem.FlatRateMarkup && dataItem.PercentMarkup) {
                            percentage = ((dataItem.Rate.total * dataItem.PercentMarkup) / 100);
                            markupText = `(+ ${dataItem.PercentMarkup}%)`
                        }
                        rate = dataItem.Rate.total + percentage + flatRate
                        return `<div class="rate-mark-details-wrapper">
                        <b>${parseFloat(rate).toFixed(2)}</b>
                        <div class="markup-details">${markupText}</div>
                        </div>`;
                    }
                }

            });
        }
        this.state = {
            selector: "availableRates",
            availableRatesGridData: null,
            rateShopWarningsData: [],
            isOpenViewRateShoppingWarningsModal: false,
            rateShopDetailsData: [],
            isOpenViewRateShoppingDetailsModal: false,
            carrierRoutingData: null,
            selectedRateItems: null,
            saveRateLoading: false,
            selectedRate: 0,
            gridColumns: tmpGridColumns,
            gridSchema: {
                data: [],
                schema: {
                    model: {
                        fields: {
                            Carrier: {
                                type: "string",
                                editable: false
                            },
                            Service: {
                                type: "string",
                                editable: false
                            },
                            Eta: {
                                type: "string",
                                editable: false
                            },
                            Rate: {
                                type: "string",
                                editable: false
                            },
                            MarkupRate: {
                                type: "string",
                                editable: false
                            },
                            CarrierAccount: {
                                type: "string",
                                editable: false
                            },
                            Nickname: {
                                type: "string",
                                editable: false
                            }
                        }
                    }
                }
            }
        }
    }

    componentDidMount() {
        this._isMounted = true;
        kendo.ui.progress($('#AvailableRates'), true);
        smallParcelService.initialAvailableRates(this.props.customerId, this.props.sharedSelectedOrderIds).then((response) => {
            this.setState({
                carrierRoutingData: response.data
            });
        });
        let dataObj = {
            "OrderIds": this.props.sharedSelectedOrderIds,
            "ReturnAllRates": true,
            "MultiOrderRateShopOnShip": false
        }
        smallParcelService.parcelAutoRateShopperStarter(dataObj).then((response) => {
            if(response && response.data) {
                this.getParcelAutoRateShopperStatus(response.data);
            }
        });

        $(document).off("click", ".rate-details");
        $(document).on("click", ".rate-details", showRateDetails);
        let self = this;
        function showRateDetails() {
            let grid = $("#" + self.props.windowId + 'gridAvailableRates').data("kendoGrid");
            let selectedRate = grid.select();

            if (selectedRate.length == 1) {
                self.setState({
                    isOpenViewRateShoppingDetailsModal: true,
                    rateShopDetailsData: grid.dataItem(selectedRate[0])
                });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.warningsLinkElement) {
            this.warningsLinkElement.removeEventListener("click", this.onViewRateShoppingWarningsClick);
            this.warningsLinkElement = null;
        }
    }

    getParcelAutoRateShopperStatus = (data) => {
        smallParcelService.parcelAutoRateShopperStatus(data.StatusRelativeUri).then((response) => {
            if(response.data.Done) {
                let tmpAvailableRatesGridData = [];
                if (response.data.Rates && response.data.Rates.ResourceList) {
                    tmpAvailableRatesGridData = [...response.data.Rates.ResourceList].sort((a, b) => a.Rate.total - b.Rate.total);
                }
                this.setState({
                    availableRatesGridData: tmpAvailableRatesGridData,
                    rateShopWarningsData: response.data.Rates.FaultedOrders ? response.data.Rates.FaultedOrders.Faults : []
                });
                kendo.ui.progress($('#AvailableRates'), false);
            } else {
                setTimeout(() => {
                    this.getParcelAutoRateShopperStatus(response.data);
                }, 3000);
            }
        }, (err) => {
            kendo.ui.progress($('#AvailableRates'), false);
            this.props.onCloseAvailableRatesModel();
        });
    };

    selectAvailableRates = () => {
        this.setState({ saveRateLoading: true });
        // Create the ChosenRate dynamic JSON object
        const jsonObject = {
            requestId: this.state.selectedRateItems.RequestId,
            serviceName: this.state.selectedRateItems.Service,
            packageType: this.state.selectedRateItems.PackageType,
            carrier: {
                refKey: this.state.selectedRateItems.Carrier,
                refValue: this.state.selectedRateItems.CarrierAccount,
                provider: this.state.selectedRateItems.Provider,
                nickname: this.state.selectedRateItems.Nickname
            },
            serviceCode: this.state.selectedRateItems.ServiceCode,
            estimatedDelivery: {
                utcDate: StringWms.convertFilterStringToISODate(this.state.selectedRateItems.DeliveryDate,'',false, true).isoStringUTC,
                days: this.state.selectedRateItems.Days
            },
            amounts: this.state.selectedRateItems.Rate,
            rateDetails: this.state.selectedRateItems.RateDetails,
            splitPackageRates: this.state.selectedRateItems.SplitPackageRates,
            meta: this.state.selectedRateItems.Meta
        };

        let routingFormObj = this.state.carrierRoutingData;
        if(String(routingFormObj?.Carrier?.Value).trim() !== String(this.state?.selectedRateItems?.Carrier).trim()) {
            routingFormObj.ScacCode.Value = this.props.onGetScacCode(this.state.selectedRateItems);
            routingFormObj.ScacCode.HasChanged = true;
        }
        routingFormObj.Carrier.Value = this.state.selectedRateItems.Carrier;
        routingFormObj.Carrier.HasChanged = true;
        routingFormObj.AccountNumber.Value = this.state.selectedRateItems.CarrierAccount;
        routingFormObj.AccountNumber.HasChanged = true;
        routingFormObj.Service.Value = this.props.onGetServiceCode(this.state.selectedRateItems);
        routingFormObj.Service.HasChanged = true;
        routingFormObj.ChosenRate.Value = JSON.stringify(jsonObject);
        routingFormObj.ChosenRate.HasChanged = true;
        this.props.setQuotedRates(this.state.selectedRateItems.Rate);
        smallParcelService.updateRateCarrierAndServices({
            'massRoutingData': routingFormObj,
            'orderIds': this.props.sharedSelectedOrderIds
        }).then((response) => {
            GlobalService.notification('success', this.translate('Rate_Save_Success'));
            this.props.updateCarrierAndServiceInfo()
            this.props.onCloseAvailableRatesModel();
        }).finally(() => {
            if (this._isMounted) {
                this.setState({ saveRateLoading: false });
            }
        });
    }

    onRowSelected = () => {
        let grid = $("#" + this.props.windowId + 'gridAvailableRates').data("kendoGrid");
        let selectedRate = grid.select();
        let selectedRateItems = null;

        if (selectedRate.length == 1) {
            selectedRateItems = grid.dataItem(selectedRate[0]);
        }

        this.setState({
            selectedRateItems: selectedRateItems,
            selectedRate: selectedRate.length
        });
    }

    // Kendo's window appendTo moves this modal to #root, outside the Small Parcel
    // React root, so React onClick on the warnings link never fires. Bind natively.
    setWarningsLinkRef = (element) => {
        if (this.warningsLinkElement === element) {
            return;
        }
        if (this.warningsLinkElement) {
            this.warningsLinkElement.removeEventListener("click", this.onViewRateShoppingWarningsClick);
        }
        this.warningsLinkElement = element;
        if (this.warningsLinkElement) {
            this.warningsLinkElement.addEventListener("click", this.onViewRateShoppingWarningsClick);
        }
    }

    onViewRateShoppingWarningsClick = (event) => {
        event.preventDefault();
        this.viewRateShoppingWarnings();
    }

    viewRateShoppingWarnings = () => {
        this.setState({ isOpenViewRateShoppingWarningsModal: true });
    }

    onCloseViewRateShoppingModal = () => {
        this.setState({ isOpenViewRateShoppingWarningsModal: false });
    }

    onCloseViewRateShoppingDetailModal = () => {
        this.setState({ isOpenViewRateShoppingDetailsModal: false });
    }

    render() {
        return (
            <>
                <WmsModel
                    id='AvailableRates'
                    class="available-rates-model-wrapper"
                    title={this.translate('Lable_Available_Rates')}
                    width={1000}
                    height={800}
                    onCloseFunc={this.props.onCloseAvailableRatesModel}
                    isOpen={this.props.isAvailableRatesModelOpen}
                    customClass='wms-model-new-ui-wrapper'
                >

                    <div className="wms-area-content-darker model-content-wrapper wms-area-partial-border">
                        <div className="flex-container">
                            <div className="flex-item-left">{this.translate('Lable_Available_Rates_Description')}</div>
                            {this.state.rateShopWarningsData.length > 0 && (
                                <div className="flex-item-right">
                                    <a href="#" ref={this.setWarningsLinkRef}>
                                        {this.translate('Lable_View_Rates_Shopping_Warnings')}
                                    </a>
                                </div>
                            )}
                        </div>
                        <WmsFormGrid
                            id={this.props.windowId + 'gridAvailableRates'}
                            wmsSelector={'gridAvailableRates'}
                            gridKeySelection={'DocName'}
                            columns={this.state.gridColumns}
                            staticGridData={this.state.availableRatesGridData}
                            schema={this.state.gridSchema}
                            isColumnsResizable={true}
                            isColumnsReorderable={true}
                            isColumnMenuenable={false}
                            isColumnsSortable={true}
                            parentClassName={'grid-section'}
                            showResetMenu={false}
                            onSelection={this.onRowSelected}
                            IsMultipleSelectable={true}
                        />
                    </div>

                    <div className="footer-btn-holder">
                        <WmsButton
                            label={this.translate('Label_Cancel')}
                            wmsSelector={this.state.selector + "Cancel"}
                            onClickFunc={this.props.onCloseAvailableRatesModel}
                            disabled={false}
                            loading={false}
                            buttonType='orange'
                            icon={'fa-ban'}
                        />
                        <WmsButton
                            id={'AvailableRates' + this.props.windowId}
                            label={this.translate('Label_Save')}
                            wmsSelector={this.state.selector + "Save"}
                            onClickFunc={this.selectAvailableRates}
                            loading={this.state.saveRateLoading}
                            disabled={this.state.selectedRate != 1}
                            tooltipText={
                                (this.state.selectedRate == 0) ?
                                    this.translate("Select_Rate_Tooltip")
                                    : this.translate("Single_Rate_Save_Tooltip")

                            }
                            showToolTip={this.state.selectedRate != 1}
                            icon="fa-floppy-o"
                        />
                    </div>
                </WmsModel>
                {this.state.isOpenViewRateShoppingWarningsModal &&
                    <ViewRateShoppingWarnings
                        open={this.state.isOpenViewRateShoppingWarningsModal}
                        rateShoppingWarningData={this.state.rateShopWarningsData}
                        onClose={this.onCloseViewRateShoppingModal}
                    />
                }
                {this.state.isOpenViewRateShoppingDetailsModal &&
                    <ViewRateShoppingDetails
                        open={this.state.isOpenViewRateShoppingDetailsModal}
                        rateShopDetailsData={this.state.rateShopDetailsData}
                        onClose={this.onCloseViewRateShoppingDetailModal}
                    />
                }
            </>
        );
    }
}